import React from "react";
import { Avatar, Icon, Popover } from "antd";
import patreonMembers from "../data/patreonMembers";

const cfUrl = "https://d1wumrtbuo797i.cloudfront.net/";

const PatreonList = () => (
  <div
    style={{
      maxWidth: "50%",
    }}
  >
    {patreonMembers.map(({ thumb_url, url, level, full_name }) => {
      const color =
        level === "Top supporter" || level === "Gold"
          ? "gold"
          : level === "Silver"
          ? "silver"
          : "#cd7f32 ";

      return (
        <div
          className="hvr-grow"
          key={full_name}
          style={{ display: "inline-block", position: "relative" }}
        >
          <a rel="noopener" href={url} style={{ marginRight: "1em" }} target="_blank">
            <Popover
              content={
                <div>
                  <span style={{ color: "#212121" }}>{full_name}</span>

                  <Icon
                    className="hvr-buzz"
                    type={level === "Top supporter" ? "crown" : "trophy"}
                    theme="filled"
                    style={{
                      filter: "drop-shadow( rgba(255,255,255,1) 1px 1px 2px)",
                      fontSize: "1.5em",
                      color,
                    }}
                  />
                </div>
              }
            >
              <Avatar
                alt="Patreon Badge"
                style={{
                  border: `3px solid  ${color}`,
                  borderRadius: "50%",
                  boxShadow: "2px 3px 5px 0px rgba(0,0,0,0.5)",
                }}
                size={64}
                src={cfUrl + thumb_url}
              />
              <Icon
                className="hvr-buzz"
                type={level === "Top supporter" ? "crown" : "trophy"}
                theme="filled"
                style={{
                  filter: "drop-shadow( rgba(0,0,0,1) 1px 1px 2px)",
                  fontSize: "1.5em",
                  color,
                  position: "absolute",
                  top: 0,
                  right: 0,
                }}
              />
            </Popover>
          </a>
        </div>
      );
    })}
    <a
      className="patreon"
      style={{
        cursor: "pointer",
        borderRadius: 4,
        marginLeft: "1em",
        padding: 6,
        boxShadow: "1px 1px 3px rgba(0, 0, 0, 0.5)",
        // border: "2px solid #f96854 ",
        background: "#f96854",
        textDecoration: "none",
      }}
      rel="noopener noreferrer"
      target="_blank"
      href="https://www.patreon.com/textureninja"
    >
      <div className="hvr-buzz">
        <PatreonIcon />
      </div>

      <span style={{ fontSize: "1.2em", fontWeight: 500, color: "#fff" }}> BECOME A PATRON</span>
    </a>
  </div>
);

export default PatreonList;

const PatreonIcon = () => (
  <svg
    style={{
      width: "2em",
      height: "2em",
    }}
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000" version="1">
      <path fill="#fff" d="M999 361a360 360 0 1 1-720 0 360 360 0 0 1 720 0" />
      <path fill="#002c49" fillRule="evenodd" d="M1 1h176v961H1V1" />
    </svg>
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/PatreonList.js